<template>
  <div class="wg-row">
    <!-- Modale per la cancellazione file -->
    <wg-modal simple v-if="selectedFileToDelete != null" @closeModal="selectedFileToDelete = null;">
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'Delete file?', 'Cancellare file?') }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input 
              type="button" 
              class="small com-anm22-button-red" 
              :value="$anm22.strLang(lang, 'OK', 'OK')" 
              @click="removeFile">
          <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
          <input 
              type="button" 
              class="small" 
              :value="$anm22.strLang(lang, 'Cancel', 'Annulla')" 
              @click="selectedFileToDelete = null;">
        </div>
      </div>
    </wg-modal>
    <div class="wg-row">
      <div class="wg-row com-anm22-app-text-l">
        {{ $anm22.strLang(lang, 'Customer documents', 'Documenti cliente') }}
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <anm22-file-uploader
        :uploadUrl="'paglierani/file-upload?projectId='+project.idWorldProject"
        :allowedExtensions="['xls','xlsx','pdf','doc','docx','ps','ai','eps','jpg','jpeg','png','svg','dwg']"
        :onSuccess="addFile"
      ></anm22-file-uploader>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="com-anm22-app-text-l" v-if="uploads.length === 0">
        {{ $anm22.strLang(lang, 'No uploads', 'Nessun caricamento') }}
      </div>
      <div
          v-for="(file, i) in uploads.slice(0).sort((a,b) => b.ts - a.ts)"
          :key="'upload-'+i"
          class="wg-row file-div"
          @click="openFile(file)">
        <!-- miniatura se possibile -->
        <img 
            class="com-anm22-app-img-fixed-height-l"
            :src="getFileSrc(file.url)">
        <!-- nome file -->
        <div class="com-anm22-app-text-l" style="overflow:hidden;flex-wrap:wrap;word-wrap:break-word;">
          {{ getFileName(file.url) }}
        </div>
        <!-- delete -->
        <img 
            class="com-anm22-app-img-fixed-height-m"
            style="margin-left:auto;"
            :src="$anm22.icons.getWorldIcon('deleteBlack')"
            @click.stop="selectedFileToDelete = getFileName(file.url);">
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <paglierani-widget-history
          :projectId="project.idWorldProject"></paglierani-widget-history>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Anm22FileUploader from "../../../../../../world/spa/components/Anm22FileUploader.vue";
import PaglieraniWidgetHistory from "./PaglieraniWidgetHistory.vue"

export default {
  components: {
    Anm22FileUploader,
    PaglieraniWidgetHistory
  },
  props: {
    projectId: [Number, String],
    docs: Object
  },
  data() {
    return {
      uploads: [],
      selectedFileToDelete: null
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: state => state.auth.user
    }), 
    project() {
      return this.$store.getters['projects/get']([this.projectId]);
    }
  },
  methods: {
    getFileName(url) {
      return url.split('/').reverse()[0];
    },
    getFileSrc(url) {
      if(/\.(jpe?g|png|gif|svg)$/i.test( url )) {
        return this.$anm22.getImagePath(url);
      } else {
        var re = /(?:\.([^.]+))?$/;
        var ext = re.exec(url)[1];
        if (ext) {
          ext = ext.toLowerCase();
        }
        if ((ext == 'pdf')
            || (ext == 'ai')
            || (ext == 'cad')
            || (ext == 'doc')
            || (ext == 'docx')
            || (ext == 'eps')
            || (ext == 'html')
            || (ext == 'js')
            || (ext == 'ppt')
            || (ext == 'pptx')
            || (ext == 'txt')
            || (ext == 'xls')
            || (ext == 'xlsx')
            || (ext == 'xml')
            || (ext == 'zip')
            ) {
              return 'https://www.anm22.it/app/tasks/utilities/img/file/' + ext + '.svg';
        } else {
            return this.$anm22.icons.getWorldIcon('fileDefault');
        }
      }
    },
    saveForm() {
      const docs = {...this.docs};
      docs.uploads = this.uploads;
      this.$emit('save', docs);
    },
    addFile(data) {
      if(data.url) {
        // get last release
        this.uploads.push({
          url: data.url,
          user: this.user.idWorldUser,
          ts: this.$moment().unix()
        });
        this.saveForm();
      }
    },
    async removeFile() {
      const name = this.selectedFileToDelete;
      const index = this.uploads.findIndex(u => this.getFileName(u.url) == name);
      this.selectedFileToDelete = null;
      const url = this.uploads[index].url;
      this.uploads.splice(index, 1);
      this.saveForm();
    },
    openFile(file) {
      window.open(this.$anm22.getImagePath(file.url), '_blank');
    }
  },
  created() {
    this.uploads = this.docs.uploads.slice(0);
  }
}
</script>

<style lang="scss" scoped>
.file-div {
  flex-wrap:nowrap;
  align-items:center;
  margin-top:5px;
  height: 36px;
  border-radius: 4px;
  cursor:pointer;
  &:hover {
    background-color: #ddd;
  }
  img {
    margin: 4px;
    border-radius: 4px;
    width: 30px;
  }
}
</style>
